import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { MdDarkMode, MdLightMode } from 'react-icons/md';

import { changeTheme } from '../../store/modules/theme/actions';

import * as s from './styles';

const ThemeSelect = () => {
  const dispatch = useDispatch();
  const { title } = useContext(ThemeContext);
  const isDark = title === 'DARK';

  const toggleTheme = () => {
    dispatch(changeTheme(isDark ? 'LIGHT' : 'DARK'));
  };

  return (
    <s.ToggleThemeContainer
      isDark={isDark}
      onClick={toggleTheme}
      title={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
    >
      <s.IconWrapper active={!isDark}>
        <MdLightMode size={14} />
      </s.IconWrapper>
      <s.IconWrapper active={isDark}>
        <MdDarkMode size={14} />
      </s.IconWrapper>
      <s.Slider isDark={isDark} />
    </s.ToggleThemeContainer>
  );
};

export default ThemeSelect;
